import gql from "graphql-tag";

export const RUN_JOB_STEP = gql`
	mutation runJobStep($jobRunId: Int!, $stepId: Int!) {
		runJobStep(input: { jobRunId: $jobRunId, stepId: $stepId }) {
			jobStepRun {
				id
			}
		}
	}
`;
